import { render, staticRenderFns } from "./messageBaseList.vue?vue&type=template&id=2a2ae97f&scoped=true"
import script from "./messageBaseList.vue?vue&type=script&lang=js"
export * from "./messageBaseList.vue?vue&type=script&lang=js"
import style0 from "./messageBaseList.vue?vue&type=style&index=0&id=2a2ae97f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2ae97f",
  null
  
)

export default component.exports